import { render, staticRenderFns } from "./address_form.vue?vue&type=template&id=27c9d508&"
import script from "./address_form.vue?vue&type=script&lang=js&"
export * from "./address_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports